import Vue from "vue";
import Locales from "@/utils/locales";

Vue.filter("toCurrency", function (value) {
  if (value) {
    const number = String(value);

    if (Locales.getLocaleCode() === "fr_FR") {

      const digit = number.substring(0, number.length - 5);
      const cent = number.substring(number.length - 5, number.length - 2);
      return digit + "<span class='cent'>" + cent + "</span> € ";
    } else {
      const digit = number.substring(0, number.length - 3);
      const cent = number.substring(number.length - 3, number.length);
      return digit + "<span class='cent'>" + cent + "</span>";
    }
  }
});

Vue.filter("shortDate", function (date) {
  if (date) {
    return new Date(date).toLocaleDateString();
  }
});

Vue.filter("toInt", function (qty) {
  if (qty) {
    return Math.round(qty);
  }
});

Vue.filter("longDate", function (date) {
  if (date) {
    return new Intl.DateTimeFormat("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(date));
  }
});

Vue.filter("convertTimestamp", function (timestamp) {
  return new Date(timestamp * 1000).toLocaleDateString();
});